/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { Accordion, Button, Card, Row, Col } from 'react-bootstrap';
import { useId } from 'react-id-generator';

// Own constants/actions/components
import { addNotesAction, useCrisDataAction } from 'services/actions/shopping-cart';

const AssistantsInformation = (props) => {
  const {
    isGift,
    numberOfCompanion,
    datas,
    personalData,
    register,
    errors,
    trigger,
    indexMap,
    clearErrors,
    setValue,
  } = props;
  const idNameForm = 'exp-buy-pda-ass-inf';
  const dispatch = useDispatch();
  const [idGen] = useId();
  const [isRequired, setIsRequired] = useState(false);
  const [name, setName] = useState('');
  const [lastName, setLastname] = useState('');
  const [middleName, setMiddleName] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [email, setEmail] = useState(personalData?.email || '');
  const [maxNumberOfCompanions, setMaxNumberOfCompanions] = useState(0);
  const [currentNumberOfCompanions, setCurrentNumberOfCompanions] = useState(0);
  const [companions, setCompanions] = useState([]);
  const accordionsRefs = useRef([]);

  const handleChanged = () => {
    dispatch(useCrisDataAction(indexMap, !isRequired));
    clearErrors();
    setIsRequired(true);
    setName(personalData.name);
    setLastname(personalData.lastName);
    setMiddleName(personalData.middleName);
    setPhoneNumber(personalData.phoneNumber);

    setValue(`phoneNumber-${indexMap}`, personalData.phoneNumber, { shouldValidate: true });
  };

  const handleAddNotes = (event) => {
    dispatch(addNotesAction(indexMap, event.target.value));
  };

  const handleClick = (event) => {
    const elementToToggle = event.target;
    elementToToggle.classList.toggle('open');
  };

  const addCompanion = () => {
    setCurrentNumberOfCompanions(currentNumberOfCompanions + 1);

    setCompanions([
      ...companions,
      {
        id: companions.length,
        name: '',
        lastName: '',
        middleName: '',
      },
    ]);
  };

  const handleChangeCompanion = (e, idx) => {
    const nameKey = e.target.name.split('-')[0];

    setCompanions(
      companions.map((companion) => {
        if (companion.id !== idx) return companion;

        return {
          ...companion,
          [nameKey]: e.target.value,
        };
      }),
    );
  };

  const removeCompanion = async (id) => {
    setCurrentNumberOfCompanions(currentNumberOfCompanions - 1);

    setValue(`name-${id}-${indexMap}`, '');
    setValue(`lastName-${id}-${indexMap}`, '');
    setValue(`middleName-${id}-${indexMap}`, '');

    setCompanions(companions.filter((companion) => companion.id !== id));
    await trigger('inputcheck');
  };

  useEffect(() => {
    if (personalData?.email) {
      setEmail(personalData.email);
    }
  }, [personalData]);

  const renderAddData = () => {
    return (
      /* eslint-disable react/jsx-props-no-spreading */
      <div className={idGen}>
        <h3 className="text-tangaroa">
          <i className="fas fa-user mr-2" />
          Titular de reservación
        </h3>
        <Row>
          <Col lg={12}>
            <h4 className="mt-15 text-bold text-tangaroa">Datos personales</h4>
            <input
              {...register(`type-${indexMap}`)}
              name={`type-${indexMap}`}
              data-group={indexMap}
              data-name="type"
              hidden
              type="text"
              value="PRINCIPAL"
              readOnly />
            <input type="text" hidden value={datas.id} data-group={indexMap} data-name="idexp" readOnly />
          </Col>
          <Col lg={6}>
            <div className="form-group pr-15">
              <label htmlFor={`${idNameForm}-inp-nam-ex${indexMap}`}>Nombre(s)</label>
              <input
                {...register(`name-${indexMap}`, {
                  required: !isRequired,
                  pattern: /^[ a-zA-ZÀ-ÿ\u00f1\u00d1]*$/g,
                  onChange: (e) => setName(e.target.value),
                })}
                id={`${idNameForm}-inp-nam-ex${indexMap}`}
                name={`name-${indexMap}`}
                data-group={indexMap}
                data-name="name"
                className="form-control assistant-name-data"
                placeholder="Nombre(s)"
                type="text"
                value={name} />
              {errors[`name-${indexMap}`]?.type === 'required' && <small className="error-msg">* Campo requerido</small>}
              {errors[`name-${indexMap}`]?.type === 'pattern' && <small className="error-msg">* No caracteres especiales</small>}
            </div>
          </Col>
          <Col lg={6}>
            <div className="form-group pr-15">
              <label htmlFor={`${idNameForm}-inp-las-nam-ex${indexMap}`}>Apellido Paterno</label>
              <input
                {...register(`lastName-${indexMap}`, {
                  required: !isRequired,
                  pattern: /^[ a-zA-ZÀ-ÿ\u00f1\u00d1]*$/g,
                  onChange: (e) => setLastname(e.target.value),
                })}
                id={`${idNameForm}-inp-las-nam-ex${indexMap}`}
                name={`lastName-${indexMap}`}
                data-group={indexMap}
                data-name="lastName"
                className="form-control assistant-lastname-data"
                placeholder="Apellido Paterno"
                type="text"
                value={lastName} />
              {errors[`lastName-${indexMap}`]?.type === 'required' && <small className="error-msg">* Campo requerido</small>}
              {errors[`lastName-${indexMap}`]?.type === 'pattern' && <small className="error-msg">* No caracteres especiales</small>}
            </div>
          </Col>
          <Col lg={6}>
            <div className="form-group pr-15">
              <label htmlFor={`${idNameForm}-inp-mid-nam-ex${indexMap}`}>Apellido Materno</label>
              <input
                {...register(`middleName-${indexMap}`, {
                  pattern: /^[ a-zA-ZÀ-ÿ\u00f1\u00d1]*$/g,
                  onChange: (e) => setMiddleName(e.target.value),
                })}
                id={`${idNameForm}-inp-mid-nam-ex${indexMap}`}
                name={`middleName-${indexMap}`}
                data-group={indexMap}
                data-name="middleName"
                className="form-control assistant-middlename-data"
                placeholder="Apellido Materno"
                type="text"
                value={middleName} />
              {errors[`middleName-${indexMap}`]?.type === 'pattern' && <small className="error-msg">* No caracteres especiales</small>}
            </div>
          </Col>
          <Col lg={6}>
            <div className="form-group pr-15">
              <label htmlFor={`${idNameForm}-inp-eml-ex${indexMap}`}>Correo electrónico</label>
              <input
                id={`${idNameForm}-inp-eml-ex${indexMap}`}
                name={`email-${indexMap}`}
                data-group={indexMap}
                data-name="email"
                className="form-control assistant-email-data"
                placeholder="Correo electrónico"
                readOnly
                type="email"
                value={email} />
              {errors[`email-${indexMap}`]?.type === 'required' && <small className="error-msg">* Campo requerido</small>}
              {errors[`email-${indexMap}`]?.type === 'pattern' && <small className="error-msg">* Correo electrónico no valido</small>}
            </div>
          </Col>
          <Col lg={6}>
            <div className="form-group pr-15">
              <label htmlFor={`${idNameForm}-inp-pho-ex${indexMap}`}>Teléfono celular</label>
              <input
                {...register(`phoneNumber-${indexMap}`, {
                  required: !isRequired,
                  validate: {
                    number: (value) => /^[0-9]{10}$/.test(value),
                    startedZero: (value) => /^[1-9a-zA-Z][0-9a-zA-Z]*$/.test(value),
                  },
                  onChange: (e) => setPhoneNumber(e.target.value),
                })}
                id={`${idNameForm}-inp-pho-ex${indexMap}`}
                name={`phoneNumber-${indexMap}`}
                data-group={indexMap}
                data-name="phoneNumber"
                className="form-control assistant-phoneNumber-data"
                placeholder="Teléfono celular"
                type="text"
                value={phoneNumber} />
              {errors[`phoneNumber-${indexMap}`]?.type === 'required' && <small className="error-msg">* Campo requerido</small>}
              {errors[`phoneNumber-${indexMap}`]?.type === 'number' && <small className="error-msg">* Solo 10 dígitos</small>}
              {errors[`phoneNumber-${indexMap}`]?.type === 'startedZero' && <small className="error-msg">* No debe comenzar con 0</small>}
            </div>
          </Col>
        </Row>

        {
          currentNumberOfCompanions < maxNumberOfCompanions && (
            <Row>
              <Col lg={6}>
                <div className="d-flex text-fiord mb-15">
                  <div className="br-rounded-left-fiord pl-3 pr-2 pb-2 pt-3 p-md-2 flex-grow-7 d-flex align-items-center">
                    <i className="fas fa-user mr-2" />
                    <span className="ft-12">
                      {/* eslint-disable-next-line react/jsx-one-expression-per-line */}
                      Agregar acompañante ({currentNumberOfCompanions}/{maxNumberOfCompanions})
                    </span>
                  </div>
                  <div className="flex-grow-3">
                    <button
                      type="button"
                      className="btn bg-fiord btn-min-secondary br-rounded-right"
                      onClick={addCompanion}>
                      <i className="fas fa-plus" />
                    </button>
                  </div>
                </div>
              </Col>
            </Row>
          )
        }

        {
          maxNumberOfCompanions !== 0 && currentNumberOfCompanions === maxNumberOfCompanions && (
            <Row>
              <Col lg={6}>
                <div className="d-flex text-fiord mb-15">
                  <div className="br-rounded-fiord p-10">
                    <i className="fas fa-user mr-2" />
                    <span className="ft-12">
                      {/* eslint-disable-next-line react/jsx-one-expression-per-line */}
                      Mis acompañantes ({currentNumberOfCompanions}/{maxNumberOfCompanions})
                    </span>
                  </div>
                </div>
              </Col>
            </Row>
          )
        }

        <Accordion className="text-left collapse show pr-15">
          {
            companions.map((companion, idx) => {
              return (
                // eslint-disable-next-line react/no-array-index-key
                <Card className="no-border-x mb-3 border-bottom companion" key={idx}>
                  <Accordion.Toggle
                    as={Button}
                    variant="link"
                    // eslint-disable-next-line no-return-assign
                    ref={(el) => (accordionsRefs.current[idx] = el)}
                    eventKey={`${idx}`}
                    className="p-15 text-left not-link d-flex"
                    onClick={handleClick}>
                    <h3 className="mb-0">
                      Acompañante
                      <span className="ml-1">{idx + 1}</span>
                    </h3>
                    <i
                      className="fas fa-trash-alt text-gray-chateau ml-3"
                      onClick={() => removeCompanion(companion.id)} />
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey={`${idx}`}>
                    <Card.Body className="py-0 px-15">
                      <Row>
                        <Col lg={12}>
                          <input
                            {...register(`type-${idx}-${indexMap}`)}
                            name={`type-${idx}-${indexMap}`}
                            data-group={indexMap}
                            data-name={`type-${indexMap}`}
                            data-companion={idx}
                            hidden
                            type="text"
                            value="SECONDARY" />
                        </Col>
                        <Col lg={6}>
                          <div className="form-group pr-15">
                            <label htmlFor={`${idNameForm}-inp-${idx}-nam-ex${indexMap}`}>Nombre(s)</label>
                            <input
                              {...register(`name-${idx}-${indexMap}`, {
                                required: true,
                                pattern: /^[ a-zA-ZÀ-ÿ\u00f1\u00d1]*$/g,
                                onChange: (e) => handleChangeCompanion(e, idx),
                              })}
                              id={`${idNameForm}-inp-${idx}-nam-ex${indexMap}`}
                              name={`name-${idx}-${indexMap}`}
                              data-group={indexMap}
                              data-name={`name-${indexMap}`}
                              data-companion={idx}
                              className="form-control assistant-name-second-data"
                              placeholder="Nombre(s)"
                              type="text"
                              value={companion.name} />
                            {errors[`name-${idx}-${indexMap}`]?.type === 'required' && <small className="error-msg">* Campo requerido</small>}
                            {errors[`name-${idx}-${indexMap}`]?.type === 'pattern' && <small className="error-msg">* No caracteres especiales</small>}
                          </div>
                        </Col>
                        <Col lg={6}>
                          <div className="form-group pr-15">
                            <label htmlFor={`${idNameForm}-inp-${idx}-las-ex${indexMap}`}>Apellido Paterno</label>
                            <input
                              {...register(`lastName-${idx}-${indexMap}`, {
                                required: true,
                                pattern: /^[ a-zA-ZÀ-ÿ\u00f1\u00d1]*$/g,
                                onChange: (e) => handleChangeCompanion(e, idx),
                              })}
                              id={`${idNameForm}-inp-${idx}-las-ex${indexMap}`}
                              name={`lastName-${idx}-${indexMap}`}
                              data-group={indexMap}
                              data-name={`lastName-${indexMap}`}
                              data-companion={idx}
                              className="form-control assistant-lastname-second-data"
                              placeholder="Apellido Paterno"
                              type="text"
                              value={companion.lastName} />
                            {errors[`lastName-${idx}-${indexMap}`]?.type === 'required' && <small className="error-msg">* Campo requerido</small>}
                            {errors[`lastName-${idx}-${indexMap}`]?.type === 'pattern' && <small className="error-msg">* No caracteres especiales</small>}
                          </div>
                        </Col>
                        <Col lg={6}>
                          <div className="form-group pr-15">
                            <label htmlFor={`${idNameForm}-inp-${idx}-mid-ex${indexMap}`}>Apellido Materno</label>
                            <input
                              {...register(`middleName-${idx}-${indexMap}`, {
                                pattern: /^[ a-zA-ZÀ-ÿ\u00f1\u00d1]*$/g,
                                onChange: (e) => handleChangeCompanion(e, idx),
                              })}
                              id={`${idNameForm}-inp-${idx}-mid-ex${indexMap}`}
                              name={`middleName-${idx}-${indexMap}`}
                              data-group={indexMap}
                              data-name={`middleName-${indexMap}`}
                              data-companion={idx}
                              className="form-control assistant-middlename-second-data"
                              placeholder="Apellido Materno"
                              type="text"
                              value={companion.middleName} />
                            {errors[`middleName-${idx}-${indexMap}`]?.type === 'pattern' && <small className="error-msg">* No caracteres especiales</small>}
                          </div>
                        </Col>
                      </Row>
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
              );
            })
          }
        </Accordion>
      </div>
    );
  };

  useEffect(() => {
    setMaxNumberOfCompanions(numberOfCompanion);
  }, []);

  useEffect(() => {
    accordionsRefs.current.forEach((accordion) => {
      if (accordion) {
        accordion.click();
      }
    });
  }, [currentNumberOfCompanions]);

  return (
    <>
      <div className="shopping-card-info my-30" data-id={datas.id} data-key={idGen}>
        <Row>
          <Col lg={4}>
            <img
              src={datas.image}
              alt="card-exp"
              className="w-100 p-15" />
          </Col>
          <Col lg={8} className="text-left px-30 px-lg-15">
            <h3 className="py-15">{datas.title}</h3>
            <div className="custom-control custom-radio">
              <input
                id={`${idNameForm}-rdi-use-adr-${idGen}`}
                type="radio"
                name={`useCrisData-${indexMap}`}
                data-group={indexMap}
                data-name="useCrisData"
                className="custom-control-input"
                value={false}
                checked={isRequired}
                onChange={handleChanged} />
              <label className="custom-control-label" htmlFor={`${idNameForm}-rdi-use-adr-${idGen}`}>
                Utilizar los datos registrados en Aeroméxico Rewards
              </label>
            </div>
            <div className="use-form-container">
              {renderAddData()}
            </div>
            <div className="add-form-container d-none" />
            {
              isGift === true
                ? (
                  <div className="custom-control custom-control-area custom-input-area">
                    <label htmlFor="notes">Escribe una nota</label>
                    <textarea
                      id={`${idNameForm}-txa-add-fom-${idGen}`}
                      data-key={indexMap}
                      name="notes"
                      rows="4"
                      placeholder="Agrega un mensaje (opcional)"
                      onChange={handleAddNotes} />
                  </div>
                ) : ''
            }
          </Col>
          {
            isGift === true
              ? (
                <Col lg={12}>
                  <div className="text-left gift-label">
                    <i className="fas fa-gift mr-2 text-white" />
                    <span>Esta Experiencia es un regalo</span>
                  </div>
                </Col>
              ) : ''
          }
          {
            datas.stock !== null && datas.stock < 5 ? (
              <Col lg={12}>
                <div className="text-left stock-label">
                  <i className="fas fa-exclamation-triangle mr-2" />
                  <span>Quedan muy pocas Experiencias. ¡Date prisa!</span>
                </div>
              </Col>
            ) : ''
          }
        </Row>
      </div>
    </>
  );
};

AssistantsInformation.defaultProps = {
  personalData: {},
};

/* eslint-disable react/forbid-prop-types */
AssistantsInformation.propTypes = {
  isGift: PropTypes.bool.isRequired,
  numberOfCompanion: PropTypes.number.isRequired,
  datas: PropTypes.object.isRequired,
  personalData: PropTypes.object,
  addressData: PropTypes.object.isRequired,
  register: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  trigger: PropTypes.func.isRequired,
  indexMap: PropTypes.number.isRequired,
  setValue: PropTypes.func.isRequired,
  clearErrors: PropTypes.func.isRequired,
};

export default AssistantsInformation;
